export const handleState = (actionKey, reduce) => (state, action) => {
  if (actionKey !== action.type) return [false, state]
  const newState = reduce(state, action)
  return [true, newState]
}
